import { useNavigate } from "@reach/router";
import React, { ChangeEventHandler, useState } from "react";
import styled from "styled-components";
import { Button } from "./Button";
import { Input } from "./Input";
import { Label } from "./TextField";
import useFetchCheckRoom from "../hooks/useFetchCheckRoom";

const Element = styled.div`
  text-align: left;
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;

  & > * + * {
    margin-left: 8px;
  }
`;
const GoButton = styled(Button)`
  flex-shrink: 1;
  min-width: unset;
`;

const EnterRoomCode: React.FC = () => {
  const navigate = useNavigate();
  const checkRoom = useFetchCheckRoom();
  const [isChecking, setIsChecking] = useState(false);
  const [value, setValue] = useState("");
  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const v = e.target.value.toLowerCase().trim().replace(/-*/g, "");
    const start = v.slice(0, 4);
    const middle = v.slice(4, 8);
    const end = v.slice(8, 11);
    const nextValue =
      start + (middle ? "-" + middle : "") + (end ? "-" + end : "");
    setValue(nextValue);
  };
  const handleClick = async () => {
    setIsChecking(true);
    try {
      const { data } = await checkRoom(value);
      if (data?.ok) {
        navigate(`/${value}`);
      }
    } finally {
      setIsChecking(false);
    }
  };

  return (
    <Element>
      <Label htmlFor="code">Enter Room Code</Label>
      <Row>
        <Input
          id="code"
          name="join"
          placeholder="xxx-xxxx-xxx"
          value={value}
          onChange={handleChange}
          autoCapitalize="false"
          autoComplete="false"
          autoCorrect="false"
          spellCheck="false"
        />
        <GoButton
          disabled={isChecking}
          appearance="secondary"
          onClick={handleClick}
        >
          Go!
        </GoButton>
      </Row>
    </Element>
  );
};

export default EnterRoomCode;
